import { Application, Greenfield } from '@inmotionnow/momentum-components-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export const UnauthorizedView: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Application.Layout>
      <Greenfield icon='🔒' title={t('UNAUTHORIZED_TITLE')}>
        <p>{t('UNAUTHORIZED_MESSAGE')}</p>
        <Link to='/'>{t('UNAUTHORIZED_PROFILE_LINK')}</Link>
      </Greenfield>
    </Application.Layout>
  )
}
